module.exports = __webpack_public_path__ + "img/enclosures-2.d57b74e2.jpeg";